/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
import { alias } from '@ember/object/computed';
import Evented from '@ember/object/evented';
import Controller, { inject as controller } from '@ember/controller';
import EmbercomBootDataModule from 'embercom/lib/embercom-boot-data';
import { inject as service } from '@ember/service';

export default Controller.extend(Evented, {
  router: service(),
  intercomEventService: service(),
  queryParams: [
    'ember_rev',
    'offset_rev_banner',
    'show_l10n',
    'debug',
    'teammate_app_rev',
    'suite',
    'standalone',
    'scenario',
  ],
  tooltipComponent: null,
  ember_rev: null,
  teammate_app_rev: null,
  offset_rev_banner: null,
  show_l10n: null,
  suite: null,
  // Not all routes used in Standalone start with `apps.app.standalone` and the CS team need something in the URL
  // to target so that questions from Standalone customers get routed to the correct inbox.
  // We should remove this code once all standalone apps run on `app.fin.ai` as we could just target on the domain at that point.
  standalone: null,
  scenario: null,
  model: {},
  shouldWarnOnNavigation: false,
  appController: controller('apps/app'),
  app: alias('appController.model'),
  isBootedInPublicAppStoreMode: EmbercomBootDataModule.isBootedInPublicAppStoreMode(),
  // eslint-disable-next-line @intercom/intercom/no-legacy-modal
  modalService: service(),
  intercomConfirmService: service(),
  clientProfilerService: service(),
});
